<script lang="ts">
    import cn from 'classnames';

    import { SpinnerSize } from '@components/common/spinner/types';

    import s from './spinner.module.css';

    export let size: SpinnerSize = SpinnerSize.Big;
    export let classes = '';
    export let pointClasses = '';
    export let isAbsolute = false;
</script>

<div class={cn(s.lds, s[size], { [s.absolute]: isAbsolute }, classes)} data-testid='spinner'>
    <div class={cn(s.point, pointClasses)}></div>
    <div class={cn(s.point, pointClasses)}></div>
    <div class={cn(s.point, pointClasses)}></div>
    <div class={cn(s.point, pointClasses)}></div>
</div>
